import { useState } from 'react'
import ProjectTab from 'components/Admin/ProjectTab'
import { useData } from 'context/DataContext'
import Loader from "utils/Loader";
import LoginModal from "components/LoginModal";

// dashboard
const Dashboard = () => {
    // data context/DataContext
    const { data, user } = useData();
    // active tab
    const [activeTab, setActiveTab] = useState(0);
    // categories list
    const tabList = [
        { name: "Fiverr", component: <ProjectTab proposal name="fiverr" /> },
        { name: "UpWork", component: <ProjectTab proposal name="upWork" /> },
        { name: "Reactjs", component: <ProjectTab name="reactjs" /> },
        { name: "Landing pages", component: <ProjectTab name="landing_pages" /> },
        { name: "Javascript", component: <ProjectTab name="javascript" /> },
        { name: "Css/Frontend", component: <ProjectTab name="frontend" /> },
        { name: "Responsive", component: <ProjectTab name="responsive" /> },
        { name: "Backend", component: <ProjectTab name="backend" /> },
        { name: "Game", component: <ProjectTab name="game" /> },
        { name: "NFT", component: <ProjectTab name="nft" /> },
    ];
    
    if (user?.isAuth) {
        if (!data?.loaded) {
            return (
                <main className="page_wrapper">
                    <div className="cs_container text_center">
                        <Loader type="imgloader" />
                    </div>
                </main>
            )
        }
        return (
            <main className="page_wrapper">
                <div className="cs_container">
                    <div className="cs_row flex-wrap btns_row justify-content-center align-items-center">
                        {tabList?.map((v, i) => (
                            <button key={i} onClick={() => setActiveTab(i)} className={`cs_btn ${activeTab === i ? 'active_cs_btn' : ""}`}>{v?.name}</button>
                        ))}
                    </div>
                    {tabList[activeTab].component}
                </div>
            </main>
        );
    } else if (user.isLoading) {
        return (
            <main className="page_wrapper">
                <div className="cs_container text_center">
                    <Loader type="imgloader" />
                </div>
            </main>
        )
    }else{
        return <LoginModal/>
    }
};


export default Dashboard;